import store from '../../store';
import { getTranslation } from './Translate';

export default (key, params = {}) => {
  const { i18n: { translations } } = store.getState();
  return getTranslation(translations, key, params);
};
